import moment from "moment";

export const useGetCurrentWeek = () => {
  const start = moment().startOf("isoWeek");
  const end = moment().endOf("isoWeek");

  return { start: start.format("MM/DD/YYYY"), end: end.format('MM/DD/YYYY') };
};
